import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared.module';
import { CreateLabComponent } from './create-lab.component';
import { IonicModule } from '@ionic/angular';
import { PhotoSelectorModule } from '../photo-selector/photo-selector.component.module';


@NgModule({
  declarations: [CreateLabComponent],
  imports: [
    CommonModule,
    SharedModule,
    IonicModule,
    PhotoSelectorModule,
  ],
  exports:[CreateLabComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CreateLabModule { }
